import React, { useRef, useEffect, useState } from 'react';
import Grid from '@material-ui/core/Grid';
import Modal from '@material-ui/core/Modal';
import Button from '@material-ui/core/Button';

import '../../../scss/components/_signal_planning.scss';

const DeleteScenario = props => {

    return (
        <Modal
            open={props.showDeleteScenario}
            onClose={() => props.setShowDeleteScenario(false)}
            aria-labelledby="Delete Scenario"
            aria-describedby="Options to delete scenario ..."            
        >
            <div className='md-delete-file-opt'>
                <Grid container>  
                    <Grid item xs={1} className='md-delete-icon'>
                        <img src={require('../../../assets/icons/warning-delete-file.svg')} />
                    </Grid> 
                    <Grid item xs={11} className='md-delete-body'>
                        <div className='md-delete-title'>
                            Delete - {props.scenarioToDelete ? props.scenarioToDelete['name'] : ""}
                        </div>
                        <div className='md-delete-question'>
                            Are you sure you want to delete this scenario? Once deleted there is no way to recover the scenario.
                        </div>
                        <div className='md-delete-actions'>
                            <Button className='md-delete-actions-cancel' onClick={() => props.setShowDeleteScenario(false)}>Cancel</Button> 
                            <Button className='md-delete-actions-delete' onClick={props.handleDeleteScenario}>Delete</Button>
                        </div>
                    </Grid> 
                </Grid> 
            </div>
        </Modal>
    )

}

export default DeleteScenario;